export default "__VITE_ASSET__vhlWJqD$__"